import { Fancybox } from "@fancyapps/ui";
/*************************************************/
/* GALLERY                                       */
/*************************************************/

export function gallery() {
    const init = () => {
       
        Fancybox.bind('[data-fancybox="gallery"]', {
            hideScrollbar: false,
            Thumbs: {
                type: "classic",
              },
          });
    };

    init();

}

